// extracted by mini-css-extract-plugin
export var actionButton = "_96-1";
export var actionButtons = "_96-2";
export var actions = "_96-0";
export var aiUnread = "_96-10";
export var alignCenter = "_96-h";
export var backWrapper = "_96-3";
export var cellContainer = "_96-4";
export var checkboxContainer = "_96-5";
export var contentContainer = "_96-6";
export var contentHeader = "_96-8";
export var conversationsTableWrapper = "_96-s";
export var draftReplyBadgeContainer = "_96-m";
export var dropdownItem = "_96-b";
export var dropdownItemsContainer = "_96-a";
export var dropdownTitle = "_96-c";
export var errorIcon = "_96-7";
export var filter = "_96-d";
export var gray = "_96-i";
export var headerActionButtons = "_96-e";
export var headerCheckboxContainer = "_96-f";
export var icon = "_96-j";
export var menuContainer = "_96-k";
export var noMoreTicketsIcon = "_96-12";
export var noMoreTicketsSubText = "_96-13";
export var oneLine = "_96-l";
export var optionsButton = "_96-n";
export var plus = "_96-o";
export var portalButtonsWrapper = "_96-g";
export var red = "_96-p";
export var scrolledTop = "_96-9";
export var search = "_96-q";
export var selectedConversationsCount = "_96-r";
export var spinner = "_96-t";
export var strong = "_96-u";
export var summaryCell = "_96-v";
export var tableContainer = "_96-11";
export var tagContainer = "_96-w";
export var threeDots = "_96-x";
export var twoLines = "_96-y";
export var unread = "_96-z";